import { useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { NAV, SITE } from '../lib/site.js'
import { Mark, Wordmark } from './Logo.jsx'
import { Icon } from './icons.jsx'
import { Button } from './ui.jsx'

const linkClass = ({ isActive }) =>
  `text-[14px] font-semibold tracking-[0.2px] transition-colors ${
    isActive ? 'text-ink' : 'text-dim hover:text-ink'
  }`

export default function Nav() {
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()

  // Close the mobile menu on navigation.
  useEffect(() => {
    setOpen(false)
  }, [pathname])

  return (
    <header className="sticky top-0 z-50 border-b border-line bg-[rgba(255,255,255,0.88)] backdrop-blur-md">
      <div className="mx-auto flex h-[68px] w-full max-w-site items-center justify-between gap-x-6 px-5 sm:px-6">
        <Link to="/" className="flex items-center gap-x-[10px]" aria-label={`${SITE.name} home`}>
          <Mark className="h-9 w-9" />
          <Wordmark />
        </Link>

        <nav className="hidden items-center gap-x-8 md:flex" aria-label="Primary">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-x-4 md:flex">
          <a
            href={SITE.phoneHref}
            className="inline-flex items-center gap-x-2 text-[14px] font-semibold text-ink"
          >
            <Icon name="phone" size={16} className="text-primary" />
            {SITE.phone}
          </a>
          <Button to="/contact" size="sm">
            Get a free audit
          </Button>
        </div>

        <button
          type="button"
          className="inline-flex h-10 w-10 items-center justify-center rounded-[9px] border border-line text-ink md:hidden"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
          aria-controls="mobile-nav"
          aria-label={open ? 'Close menu' : 'Open menu'}
        >
          <Icon name={open ? 'x' : 'menu'} size={20} />
        </button>
      </div>

      {open ? (
        <div id="mobile-nav" className="border-t border-line bg-white md:hidden">
          <nav className="flex flex-col gap-y-1 px-5 py-4" aria-label="Mobile">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `rounded-[9px] px-3 py-3 text-[15px] font-semibold ${
                    isActive ? 'bg-surface text-ink' : 'text-dim'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <div className="mt-3 flex flex-col gap-y-3 border-t border-line pt-4">
              <a
                href={SITE.phoneHref}
                className="inline-flex items-center gap-x-2 px-3 text-[15px] font-semibold text-ink"
              >
                <Icon name="phone" size={16} className="text-primary" />
                {SITE.phone}
              </a>
              <Button to="/contact" className="w-full">
                Get a free audit
              </Button>
            </div>
          </nav>
        </div>
      ) : null}
    </header>
  )
}
